'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Takes a list of page patterns (with '*' being a wildcard character),
 * and returns a function that evaluates a provided path against the initial list of patterns,
 * returning a boolean if a match exists.
 *
 * @param {string[]} pages List of page patterns. Supports * as a wildcard character.
 * @returns {function(string): boolean} Matcher function that takes a page and matches it to the initially provided list of page patterns.
 */
var createPageMatcher = exports.createPageMatcher = function createPageMatcher() {
  var pages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var matchers = pages.map(function (page) {
    return new RegExp('^' + page.replace(/\*/g, '.+') + '$');
  });
  return function (page) {
    return !!matchers.find(function (matcher) {
      return matcher.test(page);
    });
  };
};